// Same rules as Backend_Subjective_Checker/utils/unexpectedBlank.js.
// The last scanned page may be the line "blank page". That line on any
// earlier page is an unexpected blank.

import { splitOcrPages } from './ocrNoise';
import { pageSpanFromTranscript } from './ocrMissing';

const BLANK_PAGE_RE = /^blank page[.!]?$/i;
const STUDENT_HEADER_RE = /^\([^)\n]*\)[^\n|]*\|\s*Image:[^\n]*(?:\r?\n)?/i;

function withoutStudentHeader(body) {
  return String(body || '').trim().replace(STUDENT_HEADER_RE, '').trim();
}

function isBlankPageBody(body) {
  return BLANK_PAGE_RE.test(String(body || '').trim());
}

function pageLabel(header, index) {
  const page = String(header || '').match(/Page\s+(\d+)/i);
  if (page) return `p${page[1]}`;
  const file = String(header || '').match(/Image_(\d+)/i);
  if (file) return `p${file[1]}`;
  return `p${index + 1}`;
}

function transcriptPages(text) {
  const pages = [];
  for (const page of splitOcrPages(text)) {
    const raw = String(page.body || '').trim();
    const body = withoutStudentHeader(raw);
    if (!page.header && raw && !body) continue;
    if (!page.header && !body) continue;
    pages.push({ header: page.header, body });
  }
  return pages;
}

// Replace the open page's "blank page" line with "actual blank". Other pages
// stay as they are. Returns null when that page is not the blank-page line.
export function markPageActualBlank(text, pageNumber, imageName) {
  const source = String(text || '');
  const span = pageSpanFromTranscript(source, pageNumber, imageName);
  if (!span) return null;
  const chunk = source.slice(span.start, span.end);
  const nl = chunk.indexOf('\n');
  if (nl < 0) return null;
  const header = chunk.slice(0, nl).replace(/\s+$/, '');
  const rest = chunk.slice(nl + 1);
  if (!BLANK_PAGE_RE.test(rest.trim())) return null;
  const trailing = (rest.match(/\s*$/) || [''])[0];
  return `${source.slice(0, span.start)}${header}\nactual blank${trailing}${source.slice(span.end)}`;
}

export function unexpectedBlankPages(text) {
  const pages = transcriptPages(text);
  if (pages.length < 2) return [];
  const flagged = [];
  for (let i = 0; i < pages.length - 1; i++) {
    if (!isBlankPageBody(pages[i].body)) continue;
    const label = pageLabel(pages[i].header, i);
    if (!flagged.includes(label)) flagged.push(label);
  }
  return flagged;
}
